// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__AddItemButton from "../../atoms/AddItemButton.js";
import * as Buhta_cabinet__Input from "../../html/Input.js";
import * as Buhta_cabinet__Route from "../../../Route.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function ItemsListLayout(Props) {
  let createAction = Props.createAction;
  let onSearchOpt = Props.onSearch;
  let actionsOpt = Props.actions;
  let children = Props.children;
  const onSearch = onSearchOpt !== undefined ? onSearchOpt : (function (param) {
      
    });
  const actions = actionsOpt !== undefined ? actionsOpt : /* [] */ 0;
  const match = React.useState(function () {
    return "";
  });
  const setSearchText = match[1];
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("img", {
                      className: "flex-1 text-gray-400",
                      src: StaticAsset.src("/static/icons/heroicons-search.svg")
                    }),
                    className: "absolute inset-y-0 left-0 h-5 w-5 p-0.5 flex items-stretch pointer-events-none"
                  }),
                  JsxRuntime.jsx(Buhta_cabinet__Input.make, {
                    className: "block w-full pl-6 sm:text-base",
                    value: match[0],
                    placeholder: "Поиск...",
                    onChange: (function (value) {
                      Curry._1(onSearch, value);
                      Curry._1(setSearchText, (function (param) {
                        return value;
                      }));
                    })
                  })
                ],
                className: "relative flex-1"
              }),
              Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(actions, (function (index, action) {
                const Key = "action-" + String(index);
                return JsxRuntime.jsx("div", {
                  children: action
                }, Key);
              })))
            ],
            className: "ml-auto flex-1 flex space-x-2 items-center"
          }),
          createAction !== undefined ? JsxRuntime.jsx(Buhta_cabinet__AddItemButton.make, {
              className: "ml-4",
              onClick: (function (param) {
                if (createAction.TAG === /* Link */ 0) {
                  return Buhta_cabinet__Route.navigateTo(createAction._0);
                } else {
                  return Curry._1(createAction._0, undefined);
                }
              }),
              children: JsxRuntime.jsx("div", {
                children: "Создать",
                className: Cn.fromList({
                  hd: Cn.on("hidden sm:block", Belt__Belt_List.length(actions) > 1),
                  tl: /* [] */ 0
                })
              })
            }) : null
        ],
        className: "flex shrink-0 px-6 h-14 items-center border-b border-gray-200"
      }),
      children
    ],
    className: "h-full flex flex-col bg-white flex-1"
  });
}

const make = ItemsListLayout;

export {
  make,
}
/* Buhta_cabinet__AddItemButton Not a pure module */
